import { app } from "@microsoft/teams-js";
import {
  TeamsIntegrationReferenceType,
  TeamsIntegrationSystem,
  TeamsIntegrationType,
} from "@teams/types";
import { IntegrationDTO } from "@teams/types/api";

import { encodeApiUrl, fetchApiWithContext } from "./ChannelApi";

export const integrationsApi = {
  loadIntegrations: async (
    context: app.Context,
    referenceId: string,
    referenceType: TeamsIntegrationReferenceType,
    types?: TeamsIntegrationType[]
  ) => {
    const queryParams = new URLSearchParams();
    if (types) {
      queryParams.append("types", types.join(","));
    }

    const integrations = await fetchApiWithContext<IntegrationDTO[]>(
      context,
      encodeApiUrl`/v1/integrations/${referenceType}/${referenceId}`,
      { queryParams }
    );

    return integrations;
  },

  deleteIntegration: (context: app.Context, integrationId: string) => {
    return fetchApiWithContext(context, encodeApiUrl`/v1/integrations/${integrationId}`, {
      method: "DELETE",
    });
  },

  addAutolinkIntegration: (
    context: app.Context,
    referenceId: string,
    referenceType: string,
    system: TeamsIntegrationSystem,
    prefix: string,
    url: string
  ) => {
    return fetchApiWithContext(
      context,
      encodeApiUrl`/v1/integrations/autolink/${referenceType}/${referenceId}`,
      {
        body: JSON.stringify({
          system,
          prefix,
          url,
        }),
        method: "POST",
      }
    );
  },

  updateAutolinkIntegration: (
    context: app.Context,
    integrationId: string,
    system: TeamsIntegrationSystem,
    prefix: string,
    url: string
  ) => {
    return fetchApiWithContext(context, encodeApiUrl`/v1/integrations/autolink/${integrationId}/`, {
      body: JSON.stringify({
        system,
        prefix,
        url,
      }),
      method: "POST",
    });
  },
};
